export default __webpack_public_path__ + "static/media/apple.b5e4885f.png";